<template lang="html" @get_new_cropimage="clear()">
  <div class="">
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card class="pa-2">
          <v-btn  icon class="float-right " @click="dialog = false"><v-icon color="black">mdi-close</v-icon></v-btn>
          <v-container grid-list-md class="pt-8 pb-2">

            <v-card-text class="my-4" >
             
            <!-- <pre>{{cropped}}</pre> -->
          <!-- <pre>{{croppedShow}}</pre> -->
                    <!-- <img v-bind:src="cropped" /> -->
                    <!-- <img v-bind:src="croppedShow" /> -->

              <!-- <div class="px-3" v-show="isCrop">
                <img ref="previewImgEdit" :src="croppedShow" class="previewImg">
              </div> -->
              <center><v-card
              outlined
              style=" border-style: dashed; border:1.5px dashed grey"
             @click="$refs.file.click()"
                      tile
                      height="140px " width="250px"
                      v-if="!isCrop"
                    >
                   
                      <v-icon class="mt-12">mdi-cloud-upload</v-icon> <v-card-text class="py-0 pt-1">คลิกที่นี่เพื่ออัพโหลดรูปภาพ</v-card-text> <v-form enctype=multipart/form-data  v-model="valid" ref="form" v-show="!isUpload || !isCrop">
                <input type="file" accept="image/png, image/jpeg, image/jpg,image/gif" ref="file" style="display: none;" @change="renderPreview()">
                <!-- <v-btn  depressed @click="$refs.file.click()" color="green">เลือกรูป</v-btn> -->
              </v-form>
                    </v-card>
                    <div class="pt-2" v-if="!isCrop" style="font-size:13px;color:red;">*รูปควรมีสัดส่วน 8:5 เช่น 800px*500px เพื่อรองรับการแสดงผลที่ดี</div>
               
              <div class="" v-show="isCrop">
                <v-row  >
                  <v-row align="center" ><v-col col="8"><vue-croppie
                ref="croppieRef"
          
                :enableResize="false"
                :enableOrientation="true"
                @result="result"
                :viewport="x_mobile?{width: '270', height: '170'}:{width: '350', height: '220'}"
                :boundary="x_mobile?{width: '270', height: '170'}:{width: '350', height: '220'}"
              >
              </vue-croppie></v-col></v-row>
                  <!-- <v-card max-width="350px" max-height="250px" > -->
                    
              <!-- </v-card>  -->
              </v-row>

              
                <div v-if="!x_mobile">
                  <v-btn :small="$vuetify.breakpoint.xsOnly" outlined color="gray" class="mx-1"   @click="rotate(90)"><v-icon class="mr-1">mdi-rotate-left</v-icon> หมุนซ้าย</v-btn>
                  <v-btn :small="$vuetify.breakpoint.xsOnly" outlined  color="gray" class="mx-1"   @click="rotate(-90)"><v-icon class="mr-1">mdi-rotate-right</v-icon> หมนุขวา</v-btn>
                   <v-btn :small="$vuetify.breakpoint.xsOnly"  @click.native="hide()" color="gray"  class="mx-1" outlined><v-icon class="mr-1">mdi-delete</v-icon>เปลี่ยนรูปภาพ</v-btn>
                </div>
                 <div v-if="x_mobile">
                  <v-btn icon  outlined color="gray" class="mx-1"   @click="rotate(90)"><v-icon >mdi-rotate-left</v-icon> </v-btn>
                  <v-btn icon  outlined  color="gray" class="mx-1"   @click="rotate(-90)"><v-icon >mdi-rotate-right</v-icon> </v-btn>
                   <v-btn icon   @click.native="hide()" color="gray"  class="mx-1" outlined><v-icon >mdi-delete</v-icon></v-btn>
                </div>
              </div></center>
             
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
               <!-- <v-btn @click="testSendImg">send img</v-btn> -->
              <v-btn :small="$vuetify.breakpoint.xsOnly" @click="dialog = false" color="error" outlined>ยกเลิก</v-btn>
              <v-btn :small="$vuetify.breakpoint.xsOnly" color="primary" depressed @click.native="uploadFile()">บันทึก</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      dialog: false,
      header_token: { headers: { token: this.$session.get("token") } },
      valid: "",
      type: "",
      title: "",
      company: {},
      isUpload: false,
      valueProgress: 0,
      cropped: null,
      croppedShow: "",
      isCrop: false,
      send_image_crop_name: "",
    };
  },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 425) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // testSendImg() {
    //   let form = new FormData();
    //   form.append("file", this.cropped, "test_crop.png");
    //   console.log(form);
    //   this.axios
    //     .post(
    //       process.env.VUE_APP_API + "/api/v1/image/",
    //       form,
    //       this.header_token
    //     )
    //     .then((response) => {
    //       // console.log(response);
    //     });
    // },
    open(type, data) {
      if (type == "add") {
        this.type = type;
        this.croppedShow = data;
        this.cropped == null;
        this.croppedShow == "";
        this.isCrop = false;
        this.isUpload = false;
        this.valueProgress = 0;
        $(this.$refs.file).val(null);
        $(this.$refs.previewImgEdit).attr("src", "");
        this.dialog = true;
      } else {
        this.type = type;
        this.croppedShow = data;
        $(this.$refs.file).val(null);
        $(this.$refs.previewImgEdit).attr("src", this.croppedShow);
        this.dialog = true;
      }
    },
    hide() {
      // this.dialog = false;
      this.clear();
    },
    clear() {
      this.cropped == null;
      this.croppedShow == "";
      this.isCrop = false;
      this.isUpload = false;
      this.valueProgress = 0;
      $(this.$refs.file).val(null);
      $(this.$refs.previewImgEdit).attr("src", "");
      this.$emit("profileImg", "");
      this.$emit("profileImgShow", "delete");
      this.$emit("image_crop_name", "");
    },
    rotate(rotationAngle) {
      this.$refs.croppieRef.rotate(rotationAngle);
    },
    renderPreview() {
      // console.log(this.$refs.file.files[0].type);
      if (this.$refs.file.files[0].size < 8000000) {
        if (
          this.$refs.file.files[0].type == "image/png" ||
          this.$refs.file.files[0].type == "image/jpeg" ||
          this.$refs.file.files[0].type == "image/jpg" ||
          this.$refs.file.files[0].type == "image/gif"
        ) {
          this.isCrop = false;
          var reader = new FileReader();
          var me = this;
          reader.onload = function (e) {
            $(me.$refs.previewImgEdit).attr("src", e.target.result);
            me.isCrop = true;
            me.$refs.croppieRef.bind({
              url: e.target.result,
            });
          };
          // console.log(this.$refs.file.files[0].name);
          this.send_image_crop_name = this.checkLengthFileName(
            this.$refs.file.files[0].name
          );
          reader.readAsDataURL(this.$refs.file.files[0]);
        } else {
          this.$swal.fire({
            icon: "warning",
            width: 400,
            // title: "ไม่สำเร็จ",
            text: " กรุณาตรวจสอบชนิดของไฟล์",
            showConfirmButton: false,
            timer: 2000,
            showCloseButton: true,
          });
          this.clear();
        }
      } else {
        this.$swal.fire({
          icon: "warning",
          width: 400,
          // title: "ไม่สำเร็จ",
          text: " ไฟล์ต้องมีขนาดต่ำกว่า 8MB",
          showConfirmButton: false,
          timer: 2000,
          showCloseButton: true,
        });
        this.clear();
      }
    },
    checkLengthFileName(val) {
      let name_file = "";
      if (val.length < 45) {
        name_file = val;
        return name_file;
      } else {
        name_file = val.slice(0, 40);
        name_file += ".png";
        return name_file;
      }
    },
    result(output) {
      this.cropped = output;
    },
    uploadFile() {
      var options = {
        type: "blob",
        size: { width: 800, height: 500 },
        format: "png",
      };
      this.$refs.croppieRef.result(options, (output) => {
        // console.log(output);
        this.cropped = output;
        if (!this.cropped) {
          this.$swal("กรุณาเลือกไฟล์", "", "warning");
          return "";
        }
        this.$emit("profileImg", this.cropped);
      });

      options = {
        type: "base64",
        size: { width: 800, height: 500 },
        format: "png",
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.croppedShow = output;
        if (!this.croppedShow) {
          this.$swal("กรุณาเลือกไฟล์", "", "warning");
          return "";
        }
        // console.log(this.croppedShow);
        this.$emit("profileImgShow", this.croppedShow);
        this.$emit("image_crop_name", this.send_image_crop_name);
      });
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.previewImg {
  width: 50% !important;
}
.addProfileImg {
  box-shadow: none !important;
}
</style>
